import { columns, drawerFilters, toolbarActions } from './helpers'
import { useMemo, useState } from 'react'
import { toTableRowItems } from './serializers'
import { useNavigate } from 'react-router-dom'
import s from '../../../commonStyles.modules.scss'
import { useNotification } from 'hooks'
import { makeCoreGetFileRequest, makeCoreGetRequest } from 'utils/api'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { formatErrorMessage } from 'utils/formatting'
import { Table } from 'components/core-ui/Table'
import {
  getDepositOptions,
  getHubOptions,
  geTruckLocation,
  getShopOptions,
  getStatusOptions,
  getArrivalType
} from '../../api'
import {formatAndDownloadResponse, formatPayloadDate} from 'utils/helpers'

const DeliveryTruckList = () => {
  const { showNotification } = useNotification()
  const navigate = useNavigate()

  const [tableItems, setTableItems] = useState<DeliveryTruck[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isCSVExportLoading, setIsCSVExportLoading] = useState<boolean>(false)
  const [isExcelExportLoading, setIsExcelExportLoading] = useState<boolean>(false)
  const [hasFilters, setHasFilters] = useState<boolean>(false)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)

  const { data: shopOptions } = getShopOptions(showNotification)
  const { data: hubOptions } = getHubOptions(showNotification)
  const { data: depositOptions } = getDepositOptions(showNotification)
  const { data: statusOptions } = getStatusOptions(showNotification)
  const { data: truckLocationOptions } = geTruckLocation(showNotification)
  const { data: arrivalTypeOptions } = getArrivalType(showNotification)

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)

    const hasFilters = tableFilters.some(tableFilter => {
      const value = tableFilter.value;
      if (Array.isArray(value)) {
        return value.length > 0;
      } else if (typeof value === 'object' && value !== null) {
        return Object.keys(value).length > 0;
      } else {
        return value !== undefined && value !== '';
      }
    });

    setHasFilters(hasFilters);

    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: '/shop-reception/delivery-trucks',
          tableFilters,
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.list))
      setTotalCount(response.page.totalCount)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor din tabel. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }
  const exportFileCSV = async (tableState, e) => {
    await exportFile(tableState, e, false)
  }

  const exportFileExcel = async (tableState, e) => {
    await exportFile(tableState, e, true)
  }

  const exportFile = async (tableState, e, isExcelExport) => {
    (isExcelExport) ? setIsExcelExportLoading(true) : setIsCSVExportLoading(true)
    const { filters, order, orderBy } = tableState
    const url = toTableGETUrl({
      url: `/shop-reception/delivery-trucks/export`,
      extraCustomUrlParams: [
        {
          name: 'isExcelExport',
          value: isExcelExport
        }
      ],
      tableFilters: filters,
      order,
      orderBy
    })

    try {
      const response = await makeCoreGetFileRequest(url, {
        responseType: 'blob'
      })
      formatAndDownloadResponse(response);
      (isExcelExport) ? setIsExcelExportLoading(false) : setIsCSVExportLoading(false)
    } catch (error) {
      (isExcelExport) ? setIsExcelExportLoading(false) : setIsCSVExportLoading(false)
      showNotification({
        message: `A aparut o eroare la descarcarea fisierului. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const toolbar = useMemo(() => toolbarActions({
      hasFilters, totalCount,
      exportFileCSV: exportFileCSV, exportFileExcel: exportFileExcel,
      isCSVExportLoading, isExcelExportLoading }),
    [hasFilters, totalCount, exportFileCSV, exportFileExcel, isCSVExportLoading, isExcelExportLoading])


  const filters = useMemo(
    () => drawerFilters(shopOptions, hubOptions, depositOptions, statusOptions, truckLocationOptions, arrivalTypeOptions),
    [shopOptions, hubOptions, depositOptions, statusOptions, truckLocationOptions, arrivalTypeOptions]
  )

  return (
    <div className={s.mainContainer}>
      <Table
        hideCheckbox
        columns={columns(navigate)}
        items={tableItems}
        fetchData={fetchData}
        isLoading={isLoading}
        totalCount={totalCount}
        shouldRefreshData={shouldRefreshData}
        setShouldRefreshData={setShouldRefreshData}
        toolbarActions={toolbar}
        filters={filters}
        filtersLabel="Filtreaza"
        filtersButtonLabel="Filtreaza"
        appliedFiltersLabel="Filtre"
        cancelFiltersButtonLabel="Anuleaza"
        applyFiltersButtonLabel="Aplica"
        rowsPerPage={10}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </div>
  )
}

export default DeliveryTruckList
